export default __webpack_public_path__ + "static/media/logoctm.5ec81c34.png";